import React from "react";
import { Helmet } from "react-helmet-async";
import ParticlesBackground from "./ParticlesBackground";
import "./Contacthero.css";
import DesignImage from "./images/contact.png";

const Hero = ({ isDarkMode }) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Corporation",
    name: "AstraSight Technologies",
    url: "https://astrasighttech.com",
    logo: "https://astrasighttech.com/images/asighticon1.png",
    description:
      "AstraSight Technologies provides web development, software solutions, cybersecurity, and digital marketing across Africa.",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+254791865638",
      contactType: "customer service",
      areaServed: "KE",
      availableLanguage: ["English"],
    },
  };

  return (
    <>
      <Helmet>
        <title>Contact AstraSight Technologies - Leading IT Solutions in Africa</title>
        <meta
          name="description"
          content="Get in touch with AstraSight Technologies for expert web development, software solutions, cybersecurity, and digital marketing services in Africa."
        />
        <meta
          name="keywords"
          content="web development, software solutions, cybersecurity, digital marketing, AstraSight Technologies, IT solutions Africa"
        />
        <meta name="author" content="AstraSight Technologies" />
        <meta property="og:title" content="Contact AstraSight Technologies - Leading IT Solutions in Africa" />
        <meta
          property="og:description"
          content="Reach out to AstraSight Technologies for professional IT solutions tailored to your business needs."
        />
        <meta property="og:image" content="https://astrasighttech.com/contact-banner.png" />
        <meta property="og:url" content="https://astrasighttech.com/contact" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <section className={`heroabout ${isDarkMode ? "dark" : "light"}`}>
        {/* 🌐 SHARED PARTICLES BACKGROUND */}
        <ParticlesBackground isDarkMode={isDarkMode} />

        <div className="heroabout-content">
         <div className="content-left">
  <div className="text-container with-line">
    <h1 className="about-heading">
      Contact AstraSight Technologies
    </h1>
    <p className="about-paragraph">
      Need{" "}
      <strong>
        web development, software solutions, cybersecurity, or digital
        marketing?
      </strong>{" "}
      We provide cutting-edge digital solutions for businesses across Africa.
      <br />
      <br />
  
    </p>
  </div>
</div>


          <div className="image-container">
            <img
              className="about-image"
              src={DesignImage}
              alt="Contact AstraSight Technologies - IT Solutions Provider in Africa"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
